import * as React from 'react';
import { Link } from 'react-router-dom';
import { apiFetch } from '../api/api';
import { deferredUpdater, getBoardTitle } from '../utils';
import { Loading } from './Loading';

interface Board {
    boardId: number;
    title: string;
    boardVisualizationServices: {
        visualizationServiceId: string;
        name: string;
        visualizationUnits: {
            visualizationUnitId: string;
            title: string;
        }[];
    }[];
}

interface State {
    boards: Board[];
    loading: boolean;
}

export class Boards extends React.Component<{}, State> {

    constructor(props) {
        super(props);
        this.state = { boards: [], loading: true };
    }

    async componentDidMount() {
        await deferredUpdater.updateNow();
        const response = await apiFetch("api/boards");
        const boards = await response.json();
        this.setState({ boards, loading: false });
    }

    render() {
        if (this.state.loading) {
            return <Loading />;
        }
        return <div>
            <h1>Boards</h1>
            <div className="boards-grid">
                {this.state.boards.map(board => <Link key={board.boardId}
                    className="text-dark board-card" to={`/boards/${board.boardId}`}>
                    <div className="card">
                        <div className="card-body">
                            <h3 className="card-title">{getBoardTitle(board)}</h3>
                            <div className="card-text">
                                {board.boardVisualizationServices.length === 0 && "No visualization endpoints assigned"}
                                {board.boardVisualizationServices.map(service =>
                                    <div key={service.visualizationServiceId}>
                                        {service.name}: {service.visualizationUnits
                                            .map(unit => unit.title).join(", ")}
                                    </div>)}
                            </div>
                        </div>
                    </div>
                </Link>)}
            </div>
            <Link className="text-dark add-board-icon" to="/boards/new" title="Add new board">
                <i className="bi-plus-circle"></i>
            </Link>
        </div>;
    }
}
